import React from "react";

import { BlockButton } from "./button";
import { BlockFeature } from "./feature";
import { BlockHtml } from "./html";
import { BlockImage } from "./image";
import { BlockVideo } from "./video";

import styles from "./styles.modules.scss";
import { PollBlock } from "../../poll-block";
import { BlockLeaderboard } from "./leaderboard";

export const Block = (props: InboxArticleBlock) => (
    <div className={`block ${props.className ?? ""} ${styles.component}`}>
        {(() => {
            switch (props.type) {
                case "buttonBlock":
                    return <BlockButton {...props} />;
                case "featureBlock":
                    return <BlockFeature {...props} />;
                case "imageBlock":
                    return <BlockImage {...props} />;
                case "textBlock":
                    return <BlockHtml {...props} />;
                case "videoBlock":
                    return <BlockVideo {...props} />;
                case "pollBlock":
                    return (
                        <PollBlock
                            pollTitle={props.title}
                            pollId={props.poll.pollId}
                            options={props.poll.options}
                        />
                    );
                case "leaderboardBlock":
                    return (
                        <BlockLeaderboard
                            campaignId={props.campaignId}
                            {...props}
                        />
                    );
                default:
                    return <div>[MISSING COMPONENT]</div>;
            }
        })()}
    </div>
);
